<template>
  <div class="player">
    <!--解决list参数的src不生效的问题：添加 :key=currentMusicItem.src-->
    <vueAplayer ref="MusicPlayer" :key=currentMusicItem.src
                :music="currentMusicItem"
                :list="musicList"
                :showLrc="true"
                :mutex="false"
                :volume="0.5"
                listMaxHeight="0px"
                :list-folded="true" @error="onError" @ended="onEnded">
    </vueAplayer>
  </div>
</template>

<script>
import vueAplayer from "vue-aplayer";

export default {
  name: "MusicPlayer",
  components: {vueAplayer},
  data() {
    return {
      // 这个播放器一堆bug，只能尝试着自己实现播放下一首了。
      currentPlayIndex: 0,
      currentMusicItem: {
        // audioId: 0,
        // title: 'unknown',
        // artist: 'unknown',
        // 因为我需要页面加载好后，播放器也要显示出来。所以只能默认给一个能播放的，否则会报错。
        src: 'unknown',
        // src: 'https://webfs.ali.kugou.com/202307120033/646c0f3a32f7780feb78679a602b2b91/v2/555991cb99ab5d8088f033d0f1834b6e/G189/M07/02/15/nZQEAF5XuU-AbYDaAEJuNfhEoD4313.mp3'
        // pic: 'unknown',
        // lrc: '',
        // theme: ''
      },
      // 播放数据需要写在数组中，然后当前播放对象只能写成该数组[0]，否则会导致每次只能播放一首歌，不能循环播放数组中的歌。
      // 而且，再往数组中插入新的对象时，需要从头插入，否则同样只能播放数组的第一首。
      // 按照上面的来做也是有一堆bug，决定自己来控制播放列表了
      // 自己维护播放列表。这个参数只是用来占位，实际使用时是根据vux中的播放列表数据来控制的
      musicList: [],
      audioReady: false,
      isPlaying: false
    }
  },
  methods: {
    // 播放出错时触发
    onError() {
      // 由于某些原因：如请求歌曲失败或者是无效的src等，会导致播放失败
      // 获取到当前播放失败的位置

      // 判断是否为最后一个，是则提示错误，否则自动往后播放
      const lastIndex = this.playList.length - 1
      if (this.playList.length > 0 ) {
        if (this.playList[lastIndex].src === this.currentMusicItem.src) {
          this.$message.error('播放出错了')
        } else {
          const currentIndex = this.playList.findIndex((item)=>{
            return item.src === this.currentMusicItem.src
          })
          this.$message.warning('播放出错了，已自动切换到下一首')
          this.playMusic(this.playList[currentIndex+1])
        }
      }
    },
    // 停止播放时触发
    onEnded() {
      // 判断播放模式
      if (this.playMode === 'repeat-list') {
        // 列表循环
        this.currentPlayIndex++;
        if (this.currentPlayIndex >= this.playList.length) {
          // console.log('从列表第一首开始播放');
          this.currentPlayIndex = 0;
        }
      } else if (this.playMode === 'repeat-one') {
        // 单曲循环， 不对currentPlayIndex做处理
      } else if (this.playMode === 'random') {
        // 随机播放
        // 生成 [n,m)，包含n但不包含m的正整数：parseInt(Math.random()*(m-n)+n)
        // 随机生成 [0,playList.length) 的整数，概率均匀。parseInt是取整数
        this.currentPlayIndex = parseInt((Math.random() * this.playList.length).toString());
      } else {
        // 列表顺序播放
        this.currentPlayIndex++;
        if (this.currentPlayIndex >= this.playList.length) {
          // this.$message.success('列表播放完毕')
          this.$notify.success('列表播放完毕')
          // 将index设置为列表最后一首
          this.currentPlayIndex = this.playList.length - 1
          return
        }
      }
      // console.log('onEnded')
      // console.log(this.currentPlayIndex)
      this.playMusic(this.playList[this.currentPlayIndex]);
    },

    // 添加播放数据到播放列表
    addMusicItem(item) {
      this.addMusicItemToStore(item);
    },

    ready(){
      this.audioReady = true
    },
    // 播放音乐
    playMusic(item){
      if (!item || item.src === 'unknown') {
        return
      }

      if (this.$route.path === '/search') {
        this.$bus.$emit('setShowPlayer', true);
      }

      // 添加到播放列表
      this.addMusicItem(item);

      // 获取当前item在列表中的索引
      this.currentPlayIndex = this.playList.findIndex((a)=>{
        return a.audioId === item.audioId && a.quality === item.quality
      })

      // 设置播放数据
      this.currentMusicItem = item

      this.$store.commit('music/setCurrentPlaySrc', this.currentMusicItem.src)

      /*
       * 调用play() 报错The play() request was interrupted by a new load request. 解决方法
       * 主要是因为资源没准备好久开始播放了
       */
      // 方法三  最好用
      // 调用播放方法
      setTimeout(()=>{
        this.isPlaying = true
        this.$refs.MusicPlayer.play()
      }, 300)

      // 解决方法一： 这个方法不需要添加以上ready方法
      // this.$nextTick(()=>{
      //   this.$refs.MusicPlayer.play()
      // })
      // 解决方法二：
      // if(!this.audioReady){
      //   console.log('return 掉了')
      //   return
      // }
      // console.log('开始播放')
      // this.$refs.MusicPlayer.play()
      // this.audioReady = false

    },

    // 播放上一首
    playPre() {
      if (this.playList.length === 0) {
        return
      }
      if (this.currentPlayIndex === 0) {
        this.$message.info('当前已是第一首')
        return
      }
      this.playMusic(this.playList[this.currentPlayIndex-1]);
    },
    // 播放下一首
    playNext() {
      if (this.playList.length === 0) {
        return
      }
      if (this.currentPlayIndex === this.playList.length - 1) {
        this.playMusic(this.playList[0])
      } else {
        this.playMusic(this.playList[this.currentPlayIndex+1])
      }
    },

    // 从当前播放列表中移除元素
    removePlayListItem(item) {
      // 这里也可以直接判断两个对象的属性值是否都想相等
      const index = this.playList.findIndex((a)=>{
        return a.audioId === item.audioId && a.quality === item.quality
      })
      // 由于store中的playList元素发生了变化，所以这里的currentPlayIndex不是真实的目前index
      // 所以根据当前播放对象查询元素index
      const currentIndex = this.playList.findIndex((a)=>{
        return a.audioId === this.currentMusicItem.audioId && a.quality === this.currentMusicItem.quality
      })
      // console.log('player find current index:'+currentIndex)

      // 如果移除的是当前正在播放的，判断当前播放歌曲是否为最后一曲。
      if (index === currentIndex) {
        // console.log('the removed index is currentPlaying index')
        // 如果不是，则播放下一首，不管当前播放模式是什么
        if (index !== this.playList.length - 1) {
          // console.log('removed index is not the last one')
          this.playMusic(this.playList[index+1])
          // 等上面用完index后，再删，否则index取到的数据就是不对的
          this.$store.commit('music/removePlayListItem', item)
        } else {
          // console.log('removed index is the last one')
          // 如果是最后一首，则跳转到第一首，然后暂停播放
          // 这里先删，后面再判断playList是否为空时，才能取到正确数据
          this.$store.commit('music/removePlayListItem', item)
          // console.log('execute remove, now the play list length:' + this.playList.length)
          // console.log('test if the play list length is above 0')
          // console.log('回到第一首，暂停播放');
          if (this.playList.length > 0) {
            // console.log('test success, jump to first song and pause')
            this.readToPlay(this.playList[0])
          } else {
            // console.log('test failed')
            this.currentMusicItem = {
              src: 'unknown'
            }
          }
        }
      } else {
        console.log('the remove index is not current playing index, remove item directly')
        this.$store.commit('music/removePlayListItem', item)
      }
      console.log('after remove store item, playlist length:'+this.playList.length)
    },

    // 准备播放，仅仅是准备（将数据传给播放器），不播放
    readToPlay(musicItem) {
      this.playMusic(musicItem);
      setTimeout(()=>{
        this.isPlaying = false
        this.$refs.MusicPlayer.pause()
      }, 300)
    },

    // 将播放列表数据保存到store中
    setMusicListToStore(list) {
      this.$store.commit('music/setPlayList', list)
    },

    // 将播放列表数据保存到store中
    addMusicItemToStore(item) {
      this.$store.commit('music/addPlayListItem', item)
    },

  },
  computed: {
    playList() {
      return this.$store.state.music.playList
    },
    playMode() {
      return this.$store.state.music.playMode
    }
  },
  mounted() {
    // 使用全局事件总线  事件名和回调函数名最好保持一致
    this.$bus.$on('addMusicItem', this.addMusicItem)
    this.$bus.$on('playMusic', this.playMusic)
    this.$bus.$on('playPre', this.playPre)
    this.$bus.$on('playNext', this.playNext)
    this.$bus.$on('removePlayListItem', this.removePlayListItem)
  },
  watch: {
    // 监听 playList 变化，如果由空 到 有值，则设置第一个数据准备播放
    '$store.state.music.playList' (newVal) {
      if (this.currentMusicItem.src === 'unknown' && newVal.length > 0) {
        this.readToPlay(this.playList[0])
      }
    }
  },

  beforeDestroy() {
    this.$bus.$off('setShowPlayer');
  }
}
</script>

<style scoped>
.player {
  height: 100px;
}
</style>
